import {ReactNode} from "react";
import {AboutDecorationData, Product, ProductCharacteristics, ProductData} from "@/entities/product";
import {Link} from "@/shared/ui/Link";
import styles from "../ui/ProductInformation.module.scss";

type Props = {
    product: Product,
    productDataCurrent: ProductData,
    aboutDecorationData: AboutDecorationData[];
    previewLength: number;
}

export type ProductInformationSection = {
    id: string;
    title: string;
    defaultOpen: boolean;
    content: ReactNode;
};

export const getSections = (
    {product, productDataCurrent, aboutDecorationData, previewLength}: Props
): ProductInformationSection[] => {
    return [
        {
            id: "characteristics",
            title: "Характеристики",
            defaultOpen: false,
            content: (
                <div className={styles.content}>
                    <ProductCharacteristics
                        product={product}
                        productDataCurrent={productDataCurrent}
                        previewLength={previewLength}
                    />
                </div>
            ),
        },
        ...aboutDecorationData.map(item => ({
            id: item.id,
            title: item.title,
            defaultOpen: item.state,
            content: (
                <>
                    <div className={styles.content} dangerouslySetInnerHTML={{__html: item.description}}></div>
                    {item.link && (
                        <Link href={item.link} className={styles.link}>Подробнее</Link>
                    )}
                </>
            ),
        })),
    ];
}
